import axios from 'axios'

export default {

  getTags() {
    return axios({
      url: 'tags'
    })
  }

}
